/* ============================================================
   DATZZY — Collection listing interactions (Stage 3.1)
   Client-side only: filter tabs, ?goal=/?cat= deep-links, colour dots, hover
   pack image, AJAX add-to-cart (via shared window.dzCart). Reads product data
   from the server-rendered cards only — never a second product database.
   Idempotent + Theme-Editor safe.
   ============================================================ */
(function(){
  var GOALS = ['sleep', 'recovery', 'performance'];

  function initCollection(){
    var grid = document.querySelector('[data-grid]');
    if(!grid || grid.dataset.colBound) return;
    grid.dataset.colBound = '1';

    var cards = [].slice.call(grid.querySelectorAll('.ptile'));
    var tabs = [].slice.call(document.querySelectorAll('.filterbar-2 .filter-tab'));
    var emptyMsg = document.querySelector('[data-empty-filter]');

    function apply(cat){
      var visible = 0;
      cards.forEach(function(card){
        var c = card.getAttribute('data-cat'), show;
        if(cat === 'all') show = true;
        else if(cat === 'nose') show = c === 'nasal';
        else if(cat === 'mouth') show = c === 'mouth';
        else if(cat === 'refill') show = c === 'refill';
        else if(GOALS.indexOf(cat) > -1) show = (' ' + (card.getAttribute('data-goals') || '') + ' ').indexOf(' ' + cat + ' ') > -1;
        else show = true;
        card.hidden = !show;
        if(show) visible++;
      });
      if(emptyMsg) emptyMsg.hidden = visible > 0;
    }
    function setActiveTab(cat){
      var match = tabs.filter(function(x){ return x.getAttribute('data-cat') === cat; })[0];
      tabs.forEach(function(x){ x.classList.remove('active'); });
      (match || tabs[0]).classList.add('active');
    }
    tabs.forEach(function(t){
      t.addEventListener('click', function(){ var cat = t.getAttribute('data-cat'); setActiveTab(cat); apply(cat); });
    });

    // deep-link: ?goal= (no tab, keep "Wszystkie" active) or ?cat=
    var params = new URLSearchParams(location.search);
    var goal = (params.get('goal') || '').toLowerCase();
    var catP = (params.get('cat') || '').toLowerCase();
    if(GOALS.indexOf(goal) > -1){ setActiveTab('all'); apply(goal); }
    else if(catP){ setActiveTab(catP); apply(catP); }
    else { setActiveTab('all'); apply('all'); }

    // per-card: lazy hover pack, colour dots, add-to-cart
    function flash(btn){
      var lbl = btn.querySelector('[data-add-label]');
      if(lbl){ var t = lbl.textContent; lbl.textContent = 'Dodano ✓'; setTimeout(function(){ lbl.textContent = t; }, 1500); }
      else { var h = btn.innerHTML; btn.innerHTML = 'Dodano ✓'; setTimeout(function(){ btn.innerHTML = h; }, 1500); }
    }
    // Keep the add button's variant + availability CTA in sync with the chosen colour.
    function setAddState(btn, available, variantId){
      if(!btn) return;
      if(variantId) btn.setAttribute('data-variant-id', variantId);
      btn.disabled = !available;
      if(available){ btn.removeAttribute('aria-disabled'); } else { btn.setAttribute('aria-disabled', 'true'); }
      var lbl = btn.querySelector('[data-add-label]');
      if(lbl) lbl.textContent = available ? 'Dodaj do koszyka' : 'Niedostępny';
    }
    cards.forEach(function(card){
      var media = card.querySelector('.ptile-media');
      if(media){
        var load = function(){ var im = card.querySelector('.pm-pack[data-src]'); if(im){ im.src = im.dataset.src; im.removeAttribute('data-src'); } };
        media.addEventListener('mouseenter', load, { once: true, passive: true });
        media.addEventListener('focusin', load, { once: true });
        media.addEventListener('touchstart', load, { once: true, passive: true });
      }
      var addBtn = card.querySelector('[data-add]');
      card.querySelectorAll('.cdot').forEach(function(dot){
        dot.addEventListener('click', function(e){
          e.preventDefault();
          card.querySelectorAll('.cdot').forEach(function(d){ d.classList.remove('active'); });
          dot.classList.add('active');
          var render = card.querySelector('.pm-render');
          if(render && dot.dataset.render) render.src = dot.dataset.render;
          var pack = card.querySelector('.pm-pack');
          if(pack && dot.dataset.pack){ if(pack.dataset.src) pack.dataset.src = dot.dataset.pack; else pack.src = dot.dataset.pack; }
          if(addBtn) setAddState(addBtn, dot.dataset.available !== 'false', dot.dataset.variantId);
        });
      });
      if(addBtn){
        addBtn.addEventListener('click', function(e){
          e.preventDefault();
          if(addBtn.disabled) return;
          var id = addBtn.getAttribute('data-variant-id');
          if(!id || !window.dzCart) return;
          window.dzCart.add(id, 1).then(function(cart){ if(cart) flash(addBtn); });
        });
      }
    });
    /* Cart count/state/drawer are initialized once, globally, by dz-cart.js. */
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCollection);
  else initCollection();
  if(window.Shopify && window.Shopify.designMode){
    document.addEventListener('shopify:section:load', function(){ initCollection(); });
  }
})();
